import { CaseReducer, PayloadAction } from "@reduxjs/toolkit";
import { ICoreZonesInitialState } from "./types";

export const setDisplayNoFlyZones: CaseReducer<ICoreZonesInitialState, PayloadAction<boolean>> = (state, action) => {
  state.displayNoFlyZones = action.payload;
};

export const setDisplaySafeLandZones: CaseReducer<ICoreZonesInitialState, PayloadAction<boolean>> = (state, action) => {
  state.displaySafeLandZones = action.payload;
};

export const setHoveredNoFlyZoneId: CaseReducer<ICoreZonesInitialState, PayloadAction<number | null>> = (
  state,
  action,
) => {
  state.hoveredNoFlyZoneId = action.payload;
};

export default { setDisplayNoFlyZones, setDisplaySafeLandZones, setHoveredNoFlyZoneId };
